import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

import { getTranslatedTypeName } from '@module/assignment';
import { AssignmentTypeTag } from '../assignment-type-tag.component';
import { DefaultLink, SecondaryText, TextLinkButton, styleVariables } from '@lib/common';
import { styled } from '@xstyled/styled-components';
import { Button, Tooltip } from 'antd';
import { EyeOutlined } from '@ant-design/icons';
var StyledTextLinkButton = styled(TextLinkButton)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height: inherit;\n  font-weight: 600;\n  text-align: inherit;\n  white-space: inherit;\n  word-break: break-word;\n"])));
import moment from 'moment';
import { getTranslatedSubmissionOverviewStatusName, SubmissionOverviewStatusComponent } from '../submission-overview-status.component';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
var AssignerText = styled(SecondaryText)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-size: 13px;\n  margin-top: 4px;\n  display: block;\n"])));
var DeadlineText = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-size: 14px;\n  font-weight: 500;\n  color: ", ";\n"])), styleVariables.colors.gray12);
var TimeLeftText = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  font-size: 13px;\n  color: ", ";\n  margin-top: 4px;\n"])), function (_ref) {
  var isExpired = _ref.isExpired;
  return isExpired ? styleVariables.colors.gray8 : styleVariables.colors.red4;
});
var SubmissionText = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  font-size: 14px;\n  font-weight: 600;\n  color: ", ";\n"])), styleVariables.colors.gray12);

var getDeadlineInfo = function getDeadlineInfo(endTimeStr) {
  if (!endTimeStr) return null;
  var endTime = endTimeStr.length === 13 ? +endTimeStr : +endTimeStr * 1000;
  var now = moment().valueOf();
  var diff = endTime - now;

  if (diff < 0) {
    return {
      isExpired: true,
      text: 'Expired'
    };
  }

  var duration = moment.duration(diff);
  var days = Math.floor(duration.asDays());
  var hours = duration.hours();
  var minutes = duration.minutes();

  if (days > 0) {
    return {
      isExpired: false,
      text: "".concat(days, " days left")
    };
  }

  if (hours > 0) {
    return {
      isExpired: false,
      text: "".concat(hours, " hours left")
    };
  }

  return {
    isExpired: false,
    text: "".concat(minutes, " mins left")
  };
};

export var renderColumns = function renderColumns(_ref2) {
  var columnLabels = _ref2.columnLabels,
      navigateToSubmissionDetail = _ref2.navigateToSubmissionDetail;
  return [{
    title: columnLabels.idNumber,
    width: '8%',
    key: 'idNumber',
    render: function render(_, record) {
      return /*#__PURE__*/_jsx(Tooltip, {
        title: columnLabels.clickToViewDetail,
        children: /*#__PURE__*/_jsxs(DefaultLink, {
          onClick: function onClick() {
            return navigateToSubmissionDetail === null || navigateToSubmissionDetail === void 0 ? void 0 : navigateToSubmissionDetail(record.id.toString());
          },
          children: ["#", record.idNumber]
        })
      });
    }
  }, {
    title: columnLabels.title,
    width: '25%',
    key: 'title',
    sorter: {
      compare: function compare(a, b) {
        var _a$title;

        return a === null || a === void 0 ? void 0 : (_a$title = a.title) === null || _a$title === void 0 ? void 0 : _a$title.localeCompare(b === null || b === void 0 ? void 0 : b.title);
      }
    },
    render: function render(_, record) {
      return /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(StyledTextLinkButton, {
          size: "middle",
          onClick: function onClick() {
            return navigateToSubmissionDetail === null || navigateToSubmissionDetail === void 0 ? void 0 : navigateToSubmissionDetail(record.id.toString());
          },
          children: record.title
        }), /*#__PURE__*/_jsx(AssignerText, {
          children: record.assigner ? "".concat(record.assigner.firstName, " ").concat(record.assigner.lastName) : '_'
        })]
      });
    }
  }, {
    title: columnLabels.type,
    width: '14%',
    key: 'type',
    sorter: {
      compare: function compare(a, b) {
        var _a$type, _b$type;

        return a === null || a === void 0 ? void 0 : (_a$type = a.type) === null || _a$type === void 0 ? void 0 : _a$type.name.localeCompare(b === null || b === void 0 ? void 0 : (_b$type = b.type) === null || _b$type === void 0 ? void 0 : _b$type.name);
      }
    },
    render: function render(_, record) {
      return /*#__PURE__*/_jsx(AssignmentTypeTag, {
        typeId: record.type.id,
        typeName: getTranslatedTypeName(record.type.id, record.type.name, columnLabels)
      });
    }
  }, {
    title: columnLabels.submitTime,
    width: '15%',
    dataIndex: 'endTime',
    key: 'endTime',
    render: function render(_, record) {
      var isUnlimited = record.type.name === columnLabels.assignmentTypePractice && !record.endTime;

      if (isUnlimited) {
        return /*#__PURE__*/_jsx("span", {
          children: "-"
        });
      }

      var dateText = record.endTime ? moment(record.endTime.length === 13 ? +record.endTime : +record.endTime * 1000).format('MMM DD, YYYY') : '-';
      var deadlineInfo = getDeadlineInfo(record.endTime);
      return /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(DeadlineText, {
          children: dateText
        }), deadlineInfo && /*#__PURE__*/_jsx(TimeLeftText, {
          isExpired: deadlineInfo.isExpired,
          children: deadlineInfo.text
        })]
      });
    }
  }, {
    title: columnLabels.totalSubmittedSubmission,
    width: '15%',
    dataIndex: 'totalSubmittedSubmission',
    key: 'totalSubmittedSubmission',
    align: 'center',
    render: function render(_, record) {
      var maxSubmissionsStr = '1'; // Placeholder, actual model doesn't seem to expose this

      var submitted = record.report.totalSubmittedSubmission < 0 ? 0 : record.report.totalSubmittedSubmission;
      return /*#__PURE__*/_jsxs(SubmissionText, {
        children: [submitted, " / ", maxSubmissionsStr]
      });
    }
  }, {
    title: columnLabels.submissionStatus,
    width: '15%',
    key: 'submissionStatus',
    sorter: {
      compare: function compare(a, b) {
        return a.report.status.name.localeCompare(b.report.status.name);
      }
    },
    render: function render(_, record) {
      return /*#__PURE__*/_jsx(SubmissionOverviewStatusComponent, {
        statusType: record.report.status.id,
        text: getTranslatedSubmissionOverviewStatusName(record.report.status.id, columnLabels)
      });
    }
  }, {
    title: columnLabels.actions,
    width: '8%',
    align: 'center',
    render: function render(_, record) {
      return /*#__PURE__*/_jsx(Tooltip, {
        title: columnLabels.clickToViewDetail,
        children: /*#__PURE__*/_jsx(Button, {
          type: "text",
          onClick: function onClick() {
            return navigateToSubmissionDetail === null || navigateToSubmissionDetail === void 0 ? void 0 : navigateToSubmissionDetail(record.id.toString());
          },
          children: /*#__PURE__*/_jsx(EyeOutlined, {})
        })
      });
    }
  }];
};